import "./Seated.css";

export default function Seated() {
  return (
    <div>
      <div id="seated-55fdf2c0" data-artist-id="677ab365-b618-4d3c-b13e-09fe35bee058" data-css-version="2"></div>
    </div>
  );
}